import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  if (!properties.url) {
    errors.push({ key: 'url', message: 'URL is required' });
  } else {
    try {
      new URL(properties.url);
    } catch (e) {
      errors.push({ key: 'url', message: 'Invalid URL format' });
    }
  }

  if (properties.headers) {
    try {
      JSON.parse(properties.headers);
    } catch (e) {
      errors.push({ key: 'headers', message: 'Headers must be valid JSON' });
    }
  }

  if (properties.body) {
    try {
      JSON.parse(properties.body);
    } catch (e) {
      errors.push({ key: 'body', message: 'Body must be valid JSON' });
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
